/**
 * @description
 * the default data state to model data table component
 */
export default function data() {
    return {
        /**
         * @description
         * the attachable filter to request
         */
        attachFilter: {},

        /**
         * @description
         * the current busy state of fetchDataTable function
         */
        busy: false,

        /**
         * @description
         * the mutable param filters of filter form
         */
        filter: {},

        /**
         * @description
         * the items response of fetchDataTable
         */
        data: [],

        /**
         *
         */
        expand: false,

        /**
         * @description
         * the export dialog state
         */
        exportDialog: false,

        /**
         * @description
         * the export limit
         */
        exportLength: 0,

        /**
         * @description
         * the export fetch status
         */
        exportLoading: false,

        /**
         * @description
         * the export fetch status value
         */
        exportValue: 50,

        /**
         * { item_description }
         */
        occupy: 0,

        /**
         * @description
         * the column sort options
         *
         * @prop {Boolean} desc -
         * @prop {Number} index -
         */
        order: {
            desc: false,
            index: 0,
        },

        /**
         * @description
         * the pagination options
         *
         * @prop {Number} current -
         * @prop {Number} from -
         * @prop {Number} length -
         * @prop {Number} limit -
         * @prop {Number} to -
         * @prop {Number} total -
         */
        pagination: {
            current: 1,
            from: 1,
            length: 1,
            limit: this.rowsPerPage || 10,
            to: 1,
            total: 1,
        },

        /**
         * @description
         * the pagination synchronization
         *
         * @prop {Boolean} descending -
         * @prop {Number} page -
         * @prop {Number} rowsPerPage -
         * @prop {String} sortBy -
         * @prop {Number} totalItems -
         */
        paginationSync: {
            descending: false,
            page: 1,
            rowsPerPage: this.rowsPerPage,
            sortBy: '',
            totalItems: 0,
        },

        /**
         * @description
         * the print excel data (columns & rows)
         *
         * @prop {Array} columns -
         * @prop {Array} rows -
         */
        printData: {
            columns: [],
            rows: [],
        },

        /**
         * @description
         * the selected items of table
         */
        selected: [],

        /**
         * @description
         * the toolbar option states
         *
         * @prop {Boolean} filtering -
         * @prop {Boolean} helping -
         * @prop {String} search -
         */
        toolbar: {
            filtering: false,
            helping: false,
            search: '',
        },

        /**
         * @description
         * If the table has selectable columns, controls column select 
         * dialog visibility
         */
        columnSelectorDialog: false,
        
        /**
         * @description
         * If the table has selectable columns, stores the active columns
         */
        activeHeaders: null,

    }
}
